var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "pr-2", attrs: { md6: "", xs12: "" } },
            [
              _vm.isTenantAdmin
                ? _c("guidelines-detail-form", {
                    attrs: {
                      currentGuideline: _vm.currentGuideline,
                      actionName: _vm.name,
                      isAddpageForm: _vm.isAddpageForm,
                      tenantData: _vm.tenantData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "pl-2", attrs: { md6: "", xs12: "" } },
            [
              !_vm.isAddpageForm && _vm.isSystemAdmin
                ? _c("guidelines-detail-tenant", {
                    attrs: {
                      currentGuideline: _vm.currentGuideline,
                      name: _vm.name,
                      isAddpageForm: _vm.isAddpageForm,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isAddpageForm && _vm.isSystemAdmin
            ? _c("guidelines-detail-standards", {
                staticClass: "mt-2",
                attrs: {
                  currentGuideline: _vm.currentGuideline,
                  name: _vm.name,
                  isAddpageForm: _vm.isAddpageForm,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }